var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBootstrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.664,
    height: 69.664,
    viewBox: "0 0 69.664 69.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_awesome-bootstrap"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bootstrap-2",
    "data-name": "Icon awesome-bootstrap",
    d: "M45.453,45.779c0,6.595-6.176,6.442-6.83,6.442H26.045v-12.7H38.623c6.618,0,6.83,4.96,6.83,6.26Zm-7.8-11.372c.1,0,5.977.155,5.977-5.646,0-2.413-.546-5.578-5.977-5.578H26.045V34.407Zm32.01-20.546V60.3A11.645,11.645,0,0,1,58.053,71.914H11.611A11.645,11.645,0,0,1,0,60.3V13.861A11.645,11.645,0,0,1,11.611,2.25H58.053A11.645,11.645,0,0,1,69.664,13.861ZM52.567,46.7c0-3.354-1.034-9.064-7.627-10.473v-.114a8.909,8.909,0,0,0,5.806-8.652c0-1.089.311-10.073-12.067-10.073H18.931V58.026c19.94,0,21.75.261,25.44-.888,2.21-.687,8.2-2.8,8.2-10.437Z",
    transform: "translate(0 -2.25)",
    fill: "#005c4d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_awesome-bootstrap)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bootstrap-3",
    "data-name": "Icon awesome-bootstrap",
    d: "M45.453,45.779c0,6.595-6.176,6.442-6.83,6.442H26.045v-12.7H38.623c6.618,0,6.83,4.96,6.83,6.26Zm-7.8-11.372c.1,0,5.977.155,5.977-5.646,0-2.413-.546-5.578-5.977-5.578H26.045V34.407Zm32.01-20.546V60.3A11.645,11.645,0,0,1,58.053,71.914H11.611A11.645,11.645,0,0,1,0,60.3V13.861A11.645,11.645,0,0,1,11.611,2.25H58.053A11.645,11.645,0,0,1,69.664,13.861ZM52.567,46.7c0-3.354-1.034-9.064-7.627-10.473v-.114a8.909,8.909,0,0,0,5.806-8.652c0-1.089.311-10.073-12.067-10.073H18.931V58.026c19.94,0,21.75.261,25.44-.888,2.21-.687,8.2-2.8,8.2-10.437Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.99e74f97a607a17778d3d1b90b691d27.svg";
export { ForwardRef as ReactComponent };